import { Grid } from '@mui/material';
import { CustomSearch } from '.';

export type TableTabsSceneProps = {
  onChangeFilter: (value: any) => void;
  globalFilter: string;
  /**
   * Text joined to "Buscar" word
   */
  searchInputText?: string;
  showFieldFilter?:boolean;

  children: React.ReactNode;

  //
  onChangeRangeDate?: (range: Date[]) => void
  cleanFilter?: () => void
};

const TableTabsScene: React.FC<TableTabsSceneProps> = ({
  globalFilter,
  onChangeFilter,
  searchInputText,
  showFieldFilter=false,
  children,
  //
  onChangeRangeDate,
  cleanFilter

}) => {
  return (
    <Grid container spacing={2}>
      {
        showFieldFilter?
          <Grid item xs={12}>
            <CustomSearch
              onChange={onChangeFilter}
              value={globalFilter}
              text={searchInputText ?? ''}

              onChangeRangeDate={onChangeRangeDate}
              cleanFilter={cleanFilter}
            />
          </Grid>
        :null
      }

      {/* ----------- table ------------ */}
      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  );
};

export default TableTabsScene;